import React from 'react';
import { connect } from 'react-redux';
import { List } from 'antd';

import {
  Button,
  Loader,
  TextArea,
  Typography,
} from 'redpoints-front-components/index';

import { facilitatorValidationSetContentLinkUrls } from '../../../actions/facilitatorValidationActions';
import {
  getFacilitatorValidationContentLinks,
  getFacilitatorValidationContentLinkUrls,
  getFacilitatorValidationDoneIsLoading,
} from '../../../reducers/tasks/facilitatorValidation';
import FacilitatorValidationContentLinksRow from './FacilitatorValidationContentLinksRow';
import { translate } from '../../../helpers/languageHelper';

const InputLabel = () => (
  <div className="facilitator-validation-content-contentLinks-labels">
    <Typography element="span" type="primary">
      {translate('tasks.facilitatorValidation.content.contentLinks.label')}
    </Typography>
    <span className="facilitator-validation-content-contentLinks-subLabel">
      {translate('tasks.facilitatorValidation.content.contentLinks.subLabel')}
    </span>
  </div>
);

const FacilitatorValidationContentLinks = ({
  contentLinkUrls,
  contentLinks,
  facilitatorValidationSetContentLinkUrls,
  isEditing,
  isLoading,
  setIsEditing,
}) => {
  const handleContentLinkUrlsChange = ({ target }) => {
    facilitatorValidationSetContentLinkUrls({ contentLinkUrls: target.value });
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  if (isLoading) {
    return <Loader isLoading />;
  }

  if (isEditing) {
    return (
      <TextArea
        className="facilitator-validation-content-contentLinks-textarea"
        label={<InputLabel />}
        onChange={handleContentLinkUrlsChange}
        value={contentLinkUrls ?? undefined}
      />
    );
  }

  return (
    <>
      <InputLabel />
      <List
        bordered
        dataSource={contentLinks}
        renderItem={FacilitatorValidationContentLinksRow}
      />
      <Button onClick={handleEditClick} type="primary">
        {translate('tasks.facilitatorValidation.content.contentLinks.editList')}
      </Button>
    </>
  );
};

const mapStateToProps = state => ({
  contentLinkUrls: getFacilitatorValidationContentLinkUrls(state),
  contentLinks: getFacilitatorValidationContentLinks(state),
  isLoading: getFacilitatorValidationDoneIsLoading(state),
});

export default connect(mapStateToProps, {
  facilitatorValidationSetContentLinkUrls,
})(FacilitatorValidationContentLinks);
